import { render, staticRenderFns } from "./ClassInfomation.vue?vue&type=template&id=7a84ba9b&"
import script from "./ClassInfomation.vue?vue&type=script&lang=js&"
export * from "./ClassInfomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports